export default defineNuxtPlugin((nuxtApp) => {
  let isTriggered = false;

  let triggeredPercentages = [false, false, false, false, false]; // Track whether each percentage has been triggered

  function handleScrollLogEvent(percentage:number) {
    logEvent({
      options: {
        eventAction: "scroll",
        eventProperties: {
          scroll_depth: percentage
        },
        eventInteraction: true,
        eventLabel: `scroll_depth:${percentage}%`,
        eventName: "virtual_scroll",
      },
    });
  }

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrolledPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;

    // Check for the specific thresholds: 10%, 25%, 50%, 75%, 90%
    if (scrolledPercentage >= 10 && !triggeredPercentages[0]) {
      triggeredPercentages[0] = true;
      handleScrollLogEvent(10);
    }

    if (scrolledPercentage >= 25 && !triggeredPercentages[1]) {
      triggeredPercentages[1] = true;
      handleScrollLogEvent(25);
    }

    if (scrolledPercentage >= 50 && !triggeredPercentages[2]) {
      triggeredPercentages[2] = true;
      handleScrollLogEvent(50);
    }

    if (scrolledPercentage >= 75 && !triggeredPercentages[3]) {
      triggeredPercentages[3] = true;
      handleScrollLogEvent(75);
    }

    if (scrolledPercentage >= 90 && !triggeredPercentages[4]) {
      triggeredPercentages[4] = true;
      handleScrollLogEvent(90);
    }
  };

  // Attach scroll listener when the app is mounted
  nuxtApp.hook("app:mounted", () => {
    window.addEventListener("scroll", handleScroll);
  });

  // Remove scroll listener when the app is unmounted: (NO SUCH HOOK EXISTS)
  // nuxtApp.hook("app:unmounted", () => {
  //   window.removeEventListener("scroll", handleScroll);
  // });

  // Reset triggered flags on route change
  nuxtApp.hook("page:finish", () => {
    isTriggered = false; // Reset for every new page
    triggeredPercentages = [false, false, false, false, false]; // Reset percentage triggers for new page
  });

  // Optionally, you can also trigger the scroll handler on every route change by adding: (NO SUCH HOOK EXISTS)
  // nuxtApp.hook("route:changed", () => {
  //   triggeredPercentages = [false, false, false, false, false]; // Reset the triggered percentages
  // });
});